import { useGetList, useTranslate } from "ra-core";
import { formatDistanceToNow } from "date-fns";
import { de } from "date-fns/locale";

import type { LeadEvent } from "../types";

const channelLabel = (event: LeadEvent) =>
  event.channel ? ` · ${event.channel}` : "";

export const LeadTimeline = ({ leadId }: { leadId: number | string }) => {
  const translate = useTranslate();
  const { data, isPending } = useGetList<LeadEvent>("lead_events", {
    filter: { lead_id: leadId },
    sort: { field: "created_at", order: "DESC" },
    pagination: { page: 1, perPage: 100 },
  });

  if (isPending) return null;
  if (!data?.length) {
    return (
      <p className="text-sm text-muted-foreground">
        {translate("resources.leads.timeline.empty")}
      </p>
    );
  }

  return (
    <ol className="flex flex-col gap-4">
      {data.map((event) => (
        <li key={event.id} className="flex flex-col gap-1 border-l pl-4">
          <div className="text-xs text-muted-foreground">
            {formatDistanceToNow(new Date(event.created_at), {
              addSuffix: true,
              locale: de,
            })}
            {channelLabel(event)}
          </div>
          <div className="text-sm font-medium">
            {translate(`resources.leads.event.${event.type}`, {
              _: event.type,
            })}
          </div>
          {event.body ? (
            <p className="text-sm whitespace-pre-wrap">{event.body}</p>
          ) : null}
        </li>
      ))}
    </ol>
  );
};
